/**
 * Loading state (APP-001 §14, §25).
 *
 * Uses an aria-live region so screen readers announce the loading message.
 * The spinner respects prefers-reduced-motion via the token-level media query.
 */
import { Loader2 } from '@/components/icons';
import { cn } from '@/lib/utils';

export function LoadingState({ label = 'Loading…', className }: { label?: string; className?: string }) {
  return (
    <div
      role="status"
      aria-live="polite"
      className={cn('flex flex-col items-center justify-center gap-3 p-8 text-muted-foreground', className)}
    >
      <Loader2 className="h-5 w-5 animate-spin text-primary" aria-hidden="true" />
      <span className="text-sm">{label}</span>
    </div>
  );
}
